export default __webpack_public_path__ + "static/media/2.df53326b.jpg";